export const ross1000 = {
  title: "ROSS 1000 / Turismo5",
  subtitle: "Rilevazione dei flussi turistici — comunicazione regionale",

  fields: {
    region: "Regione",
    codice: "Codice struttura",
    codiceHint: "Codice della struttura assegnato dalla regione (campo «codice»).",
    username: "Utente",
    password: "Password",
    passwordHint: "Credenziali del web service ROSS 1000 (assegnate dalla regione / GIES).",
    prodotto: "Nome del software",
    camereDisponibili: "Camere disponibili",
    lettiDisponibili: "Letti disponibili",
    defaultTipoturismo: "Tipo di turismo (predefinito)",
    defaultMezzotrasporto: "Mezzo di trasporto (predefinito)",
    useTestEndpoint: "Usa ambiente di test",
    endpointResolved: "Endpoint",
    keepBlank: "(lasciare vuoto per non modificare)",
  },

  regionOptions: {
    sardegna: "Sardegna",
    lazio: "Lazio",
    veneto: "Veneto",
    emilia_romagna: "Emilia-Romagna",
    toscana: "Toscana",
    piemonte: "Piemonte",
    lombardia: "Lombardia",
    liguria: "Liguria",
    marche: "Marche",
    abruzzo: "Abruzzo",
    molise: "Molise",
    calabria: "Calabria",
    basilicata: "Basilicata",
  },

  actions: {
    saveAndVerify: "Salva e verifica",
    updateCredentials: "Aggiorna credenziali",
    verifyConnection: "Verifica connessione",
    saving: "Salvataggio...",
    verifying: "Verifica...",
  },

  status: {
    connectionOk: "Credenziali salvate e connessione verificata correttamente.",
    connectionError: "Errore di connessione. Controlla le credenziali inserite.",
    connectionPending: "Connessione non ancora verificata. Premi «Verifica connessione» per confermare.",
  },

  validation: {
    codiceRequired: "Il codice struttura è obbligatorio.",
    usernameRequired: "L'utente è obbligatorio.",
    passwordRequired: "La password è obbligatoria.",
    capacityRequired: "Indica le camere e i letti disponibili.",
  },

  toasts: {
    saveSuccess: "Credenziali salvate e connessione verificata correttamente.",
    saveWarning: "Credenziali salvate, ma la connessione non è stata verificata.",
    saveError: "Impossibile salvare le credenziali.",
    testSuccess: "Connessione con ROSS 1000 verificata correttamente.",
    testError: "Impossibile verificare la connessione.",
    statusActive: "ROSS 1000 attivato.",
    statusInactive: "ROSS 1000 disattivato.",
  },
};
